import { Ref } from "react";
import {
  CreatorFragmentCommonProps,
  CreatorFragmentHandle,
} from "@coworker/apprestructured/src/task-management/components/TaskCreatorAndEditorSheet/creator-fragments/CreatorFragment";
import { getByPath } from "@coworker/apprestructured/src/shared/helpers/object.helper";
import { isLoading } from "@coworker/apprestructured/src/task-management/loading";
import { useTranslation } from "@coworker/locales";
import TitledHeadingText from "@coworker/apprestructured/src/task-management/components/TitledHeadingText/TitledHeadingText";
import { getTypedValue } from "@coworker/apprestructured/src/shared/helpers/schemaValidator";
import LoadingCreatorFragment from "@coworker/apprestructured/src/task-management/components/LoadingCreatorFragment/LoadingCreatorFragment";
import EmptyObject from "@coworker/apprestructured/src/task-management/types/EmptyObject";

export type TitledHeadingTextCreatorFragmentConfigProps = {
  // Translation key for the title
  title: string;
  field: string;
};

type TitledHeadingTextCreatorFragmentProps = {
  configProps: TitledHeadingTextCreatorFragmentConfigProps;
  commonProps: CreatorFragmentCommonProps;
  ref?: Ref<CreatorFragmentHandle>;
};

function TitledHeadingTextCreatorFragment({
  configProps,
  commonProps,
}: TitledHeadingTextCreatorFragmentProps) {
  const { task } = commonProps;
  const { title, field } = configProps;
  const text = getTypedValue<string>(getByPath(task, field));

  const { t } = useTranslation();

  if (isLoading(text)) {
    return <LoadingCreatorFragment />;
  }

  if (text.length === 0) {
    return null;
  }

  return <TitledHeadingText label={t(title)} text={text} />;
}

export default TitledHeadingTextCreatorFragment;
